import { Modal } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import href from "@/image/href.svg";
import switchImg from "@/image/switch.svg";
import Copy from "@/components/Copy";
import { formatUnits } from "ethers";
import { formatNumber, mobileHidden } from "@/utils";
import { chainParams, evmChain } from "@/collocate";
import useAddressConvert from "@/hooks/useAddressConvert";
import useAddressType from "@/store/addressType";
import useConnectWallet from "@/store/wallet/useConnectWallet";
import useMainNetworkCoin from "@/web3Hook/useMainNetworkCoin";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ButtonPrimary from "@/components/ButtonPrimary";


const HeaderModal = ({ isModalOpen, setIsModalOpen }: { isModalOpen: boolean, setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const { disconnectWalletStore, address, chainId } = useConnectWallet()
    const { t } = useTranslation();
    const { balanceLod, balance, getMainNetworkCoin } = useMainNetworkCoin(false);
    // 地址类型
    const { setAddressType, addressType } = useAddressType();
    // 地址转换
    const changeAddressType = () => {
        const type = addressType === "0x" ? "fb" : "0x";
        setAddressType(type);
    };
    // 地址转换
    const { addressConvert } = useAddressConvert();
    // 初始化路由
    const navigate = useNavigate();
    // 关闭弹窗
    const handleOk = () => {
        setIsModalOpen(false);
    };
    // 去某个网站
    const goHref = () => {
        window.open(chainParams[chainId || evmChain[0]].blockExplorerUrls[0]);
    };
    useEffect(() => {
        if (isModalOpen) {
            getMainNetworkCoin();
        }
    }, [getMainNetworkCoin, isModalOpen])
    return (
        <Modal
            footer={null}
            title={t('header.myWallet')}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleOk}
        >
            <div className=" pt-5 whitespace-nowrap text-white">
                <div className="flex items-center justify-between ">
                    <div className="flex items-center ">
                        <span className=" text-sm mr-2  text-e3 ">{t('header.walletAddress')}</span>
                        <img
                            className=" w-4 h-4 cursor-pointer"
                            onClick={changeAddressType}
                            src={switchImg}
                            alt=""
                        />
                    </div>
                    <div>
                        <span className=" text-xs text-e3   ">FIBO{t('header.balance')}：</span>
                        <span className="text-sm text-white">
                            {balanceLod ? (
                                <LoadingOutlined />
                            ) : (
                                formatNumber(formatUnits(balance), 4)
                            )}
                        </span>
                    </div>
                </div>
                <div className=" box-border border  h-12 mt-4 flex items-center justify-between bg-3a py-4 px-3 rounded-md ">
                    <span>
                        {mobileHidden(addressConvert(address), 25, 5)}
                    </span>
                    <Copy className="w-4 h-4 ml-2" text={addressConvert(address)} />
                </div>
                <ButtonPrimary
                    className="mt-7.5"
                    block
                    onClick={() => {
                        disconnectWalletStore();
                        handleOk();
                        navigate("/");
                    }}
                    text={t('header.exitWallet')}
                />
                <div
                    className="flex items-center justify-center mt-5 cursor-pointer"
                    onClick={goHref}
                >
                    <span className=" text-grayA8 text-xs">View on Testfiboscan</span>
                    <img className="w-3 h-3 ml-2" src={href} alt="" />
                </div>
            </div>
        </Modal>
    )
}

export default HeaderModal